import { getOwnProfilePath, normalizeProfileUrl } from "./profilePaths";

export const resolveMessageNavigation = (
  message,
  user,
  { messagesPath } = {},
) => {
  const id = message?._id || message?.id;
  const resolvedMessagesPath =
    messagesPath || getOwnProfilePath(user, "/messages");
  const isSystem = Boolean(message?.isSystem || message?.systemMessage);
  const type = message?.type || "";
  const senderId = message?.data?.senderId;
  const conversationId = message?.data?.conversationId;
  const listingId = message?.data?.listingId;

  if (isSystem) {
    return {
      pathname: resolvedMessagesPath,
      state: {
        openSystemThread: true,
        systemMessageId: id,
      },
    };
  }

  if (type === "marketplace_message") {
    return {
      pathname: "/marketplace/messages",
      state: {
        startConversationWith: senderId ? { _id: senderId } : undefined,
        listingId: listingId || null,
        conversationId: conversationId || null,
      },
    };
  }

  if (type === "message" || conversationId || senderId) {
    return {
      pathname: normalizeProfileUrl(message?.url || resolvedMessagesPath, user),
      state: {
        startConversationWith: senderId ? { _id: senderId } : undefined,
        conversationId: conversationId || null,
      },
    };
  }

  return {
    pathname: resolvedMessagesPath,
    state: {},
  };
};
